














import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxGroupPanel extends Vue {
  @Prop({ type: String, default: '1024' })
  width!: string;

  @Prop({ type: String, default: '600' })
  height!: string;
}
